export default "__VITE_ASSET__3527b0ee__"